
import axios from "axios"
import ApiStore from "./ApiStore";
var querystring = require('querystring');


export class PNDocStore extends ApiStore{
  constructor() {

    super();
  }

  newPNDoc(completeFunc){
    axios.get('/paymentnote/doc/?format=json&new_pn=true')
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  newPNDocCreditInstallment(workNo,docType,completeFunc,errorFunc){
    axios.get('/'+docType+'/doc/?format=json&new_'+(docType==='cashbill'?'iv':'pn')+'=true&wo='+workNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  

  loadPNDoc(pnNo,docType,completeFunc,errorFunc){
    axios.get('/'+docType+'/doc/?format=json&'+(docType==='cashbill'?'iv':'pn')+'='+pnNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc(error)
    })
  }

  loadPNDocHistory(docType,pnNo,completeFunc){
    axios.get('/paymentnote/history/'+docType+'?format=json&pn='+pnNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  loadSupplierList(query,pageNo,completeFunc){
    axios.get('/paymentnote/supplierlist/?format=json&q='+query+'&page='+pageNo)
    .then(function(response){
      console.log(response)
      completeFunc(response.data)
    })
    .catch(function (error) {
      console.log(error);
    })
  }

  savePNDoc(postData,docType,completeFunc,errorFunc){
    console.log('postData',postData)    
    axios.post('/'+docType+'/doc',postData)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }

  updatePNDocStatus(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)    
    axios.post('/paymentnote/status/',querystring.stringify(postData))
    .then(function(response){
      console.log('response',response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
    
  }
  
  delSupplier(customerId,completeFunc,errorFunc){
    
    console.log('supplier',customerId)
    axios.delete('/paymentnote/supplier/'+customerId)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  cancelPNDoc(pnNo,stock_recordid,completeFunc,errorFunc){
        
    pnNo = pnNo.replace("/", "_");
    axios.post('/paymentnote/cancel/'+pnNo,querystring.stringify({recordid:stock_recordid}))
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  delPNDoc(pnNo,completeFunc,errorFunc){
        
    pnNo = pnNo.replace("/", "_");
    axios.delete('/paymentnote/doc/'+pnNo)
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }

  saveSupplier(postData,completeFunc,errorFunc){
    
    console.log('postData',postData)
    axios.post('/paymentnote/supplier/'+postData.shop_id,querystring.stringify(postData))
    .then(function(response){
      console.log(response.data)
      let result = response.data
      if(result.status==='OK')
        completeFunc(result)
      else
        errorFunc(result)
    })
    .catch(function (error) {
      console.log(error);
      errorFunc({status:'error',desc:error});
    })
  }
}

export default new PNDocStore()



// WEBPACK FOOTER //
// ./src/stores/PNDocStore.js